import { FC } from 'react';
import styles from './ArticlesPageButton.module.css';
import AngledBracket from '../icons/AngledBracket.svg';
import Link from 'next/link';

const ArticlesPageButton: FC = () => {
  return (
    <Link href='/learn/articles'>
      <a>
        <div className={styles['wrapper']}>
          <div className='flex text-lg font-semibold text-normal'>
            Online ministry resources
            <div className='ml-2 mt-0.5'>
              <AngledBracket className='stroke-current stroke-2' />
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default ArticlesPageButton;
